import React from 'react';
import { Check } from 'phosphor-react';
import { SNavigationButton } from '@/components/ui/atoms/SNavigationButton';
import { SFooterDrawer } from '@/components/ui/organisms/SFooterDrawer';
import { GenderEnum } from '@/types/member.types';
import './SelectGenderDrawer.css';

export interface SelectGenderDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  currentGender?: string;
  onGenderSelect?: (gender: string) => void;
}

const genderOptions = [
  { label: 'Male', value: GenderEnum.MALE },
  { label: 'Female', value: GenderEnum.FEMALE },
  { label: 'Unspecified', value: GenderEnum.UNSPECIFIED },
];

export const SelectGenderDrawer: React.FC<SelectGenderDrawerProps> = ({
  isOpen,
  onClose,
  currentGender,
  onGenderSelect,
}) => {
  const handleGenderSelect = (genderValue: string) => {
    if (onGenderSelect) {
      onGenderSelect(genderValue);
    }
    onClose();
  };

  return (
    <SFooterDrawer
      isOpen={isOpen}
      onClose={onClose}
      title="Select Gender"
      height="auto"
    >
      <div className="select-gender-drawer-content">
        {/* Gender Options List */}
        <div className="select-gender-list">
          {genderOptions.map((option) => (
            <SNavigationButton
              key={option.value}
              label={option.label}
              rightIcon={
                currentGender === option.value ? (
                  <Check size={24} color="#000000" weight="bold" />
                ) : undefined
              }
              onClick={() => handleGenderSelect(option.value)}
            />
          ))}
        </div>
      </div>
    </SFooterDrawer>
  );
};

export default SelectGenderDrawer;
